import React from 'react';
import PropTypes from 'prop-types';
import { difference } from 'lodash';
import './form.css';
import { generateId } from './../../redux/helpers';
import { calculateXYPosition, getBabyDefaultTextCoords, generateText, mergeDefaultData, BOYTEXTCOLOR, GIRLTEXTCOLOR } from './../../helpers/babyBookHelper';
import { userTextsGenerated } from './../../redux/actions/ui/babyPage';


class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = ({
      errors: []
    });
  }

  resetErrors() {
    this.setState({
      errors: [],
    });
  }

  closeLightBox() {
    this.props.close();
  }

  // eslint-disable-next-line class-methods-use-this
  handleSubmit(event) {
    this.resetErrors();
    event.preventDefault();
    const { state } = this;
    const { inputs } = this.props;

    const notValid = difference(inputs, Object.keys(state));
    if (notValid.length > 0) {
      this.setState({
        errors: notValid,
      });
    } else {
      this.refs.btn.setAttribute("disabled", "disabled");
      this.generateBabyText(state);
      this.closeLightBox();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async generateBabyText(value) {
    const {
      texts, bookProps, dispatch, pageId, bookHeight, layoutHeight, lang,
    } = this.props;
    const data = mergeDefaultData(bookProps.bookId);
    const index = generateId(Object.keys(texts), 10000);
    const getKeyTexts = getBabyDefaultTextCoords();
    let lastIndex = index;
    if (value && value) {
      for (const key in value) {
        if (key in value && key !== 'errors') {
          const {
            left,
            top,
          } = getKeyTexts[key];

          const textColor = bookProps.pageBackgroundImage.indexOf('Kislány') >= 0 ? GIRLTEXTCOLOR : BOYTEXTCOLOR;
          const properties = {
            id: lastIndex,
            color: textColor,
            text: `${lang[key]}: ${value[key]}`,
            isEditable: false,
            positions: calculateXYPosition(left, top, layoutHeight, bookHeight),
            isBabyText: true,
          };
          const textProperties = Object.assign(properties, data);
          await generateText(textProperties, pageId, lastIndex, dispatch);
          lastIndex += 10;
        }
      }
      dispatch(userTextsGenerated(true));
    }
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = target;
    const { name } = target;

    let replacedText = value.replace(/[[\]{}*+\\^$|#\t]/g, '');
    replacedText = replacedText.replace(/\s{2,}/g, ' ');

    this.setState({
      [name]: replacedText,
    });
  }

  renderErrors() {
    const { lang } = this.props;
    return (
      <span className="modal-error">
        { lang.requirement_field }
      </span>);
  }

  renderInputs() {
    const { inputs, lang } = this.props;
    const { errors } = this.state;

    return inputs.map((element, index) => {
      const textClass = 'babyTexts';

      return (
        <div key={`div-${element}`}>
          <input
            name={element}
            key={`input-${element}`}
            placeholder={lang[element]}
            onChange={this.handleInputChange}
            className={textClass}
            tabIndex={index}
          />
          { errors.find(el => el === element) && this.renderErrors() }
        </div>);
    });
  }

  render() {
    const { lang } = this.props;

    return (
      <form autoComplete="off" onSubmit={this.handleSubmit}>
        { this.renderInputs() }
        <input ref="btn" type="submit" value={lang.submit} />
      </form>
    );
  }
}

Form.defaultProps = {
  inputs: [],
  lang: {},
  close: () => {},
};

Form.propTypes = {
  inputs: PropTypes.array,
  lang: PropTypes.object,
  close: PropTypes.func,
};


export default (Form);



// WEBPACK FOOTER //
// ./src/components/form/form.jsx